import React, { useState, useEffect } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import TopSideCountBar from "./TopSideCountBar";
import DailyWeeklyReport from "./DailyWeeklyReport";
import TopLead from "./TopLead";
import MonthlyMembershipConversion from "./MonthlyMembershipConversion";
import MonthlyLeadConversion from "./MonthlyLeadConversion";
import MonthlyUserRegistration from "./MonthlyUserRegistration";
import MonthlyRevenueTrend from "./MonthlyRevenueTrend";

export default function Dashboard() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("adminToken");
    const API_URL = process.env.REACT_APP_BASE_URL_API;

    const fetchDashboardData = async () => {
        try {
            const response = await fetch(
                `${API_URL}/api/admin/dashboard-state`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },
                }
            );

            const result = await response.json();

            if (result.success) {
                setData(result.data);
            }
        } catch (error) {
            console.error("Dashboard API Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDashboardData();
    }, []);



    return (
        <div class="container body">
            <div class="main_container">
                <Sidebar />

                <Header />
                {/* page */}


                {/* page content */}
                <div className="right_col" role="main">
                    {/* top tiles */}
                    <div className="row">
                        <TopSideCountBar data={data} loading={loading} />

                        <DailyWeeklyReport data={data} loading={loading} />

                        <TopLead data={data} loading={loading} />

                        <MonthlyMembershipConversion apiData={data?.monthlyMembershipConversion || []} />
                        <MonthlyLeadConversion apiData={data?.monthlyLeadConversion || []} />
                        <MonthlyUserRegistration apiData={data?.monthlyUserRegistration || []} />
                        <MonthlyRevenueTrend apiData={data?.monthlyRevenueTrend || []} />


                    </div>


                </div>
                {/* /page content */}



                {/* page end */}
                <Footer />
            </div>
        </div>
    );
}